import { React } from 'react';
import Home from 'pages/Home/Show';
import 'assets/styles/app.scss';

function App() {
  return <Home />;
}

export default App;
